import { render, staticRenderFns } from "./search-result-item-component.vue?vue&type=template&id=301d6535&scoped=true&"
import script from "./search-result-item-component.vue?vue&type=script&lang=ts&"
export * from "./search-result-item-component.vue?vue&type=script&lang=ts&"
import style0 from "./search-result-item-component.vue?vue&type=style&index=0&id=301d6535&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "301d6535",
  null
  
)

export default component.exports